export default "__VITE_ASSET__BoPb6n6Z__"